import { api } from '../lib/api'
import type { DRFPage, PostCard } from '../types'
import type { PublishFilters } from '../types/publish'
import { serializePublishFilterParams } from '../types/publish'
import { normalizeCursor } from './cursor'

export async function getPublishFeedPage(
  cursor?: string | null,
  filters?: PublishFilters
): Promise<{ items: PostCard[]; next: string | null }> {
  const params: Record<string, string> = serializePublishFilterParams(filters)
  const endpoint = filters?.mode === 'saved' ? '/api/feed/saved' : '/api/feed/home'
  // Saved uses a dedicated endpoint; don't pass mode=... there.
  if (filters?.mode === 'saved') delete params.mode
  // "Subscriptions" is enforced client-side; avoid sending an unknown mode to the backend.
  if (filters?.mode === 'subscriptions') delete params.mode

  const cursorToken = normalizeCursor(cursor)
  if (cursorToken) params.cursor = cursorToken
  const { data } = await api.get<DRFPage<PostCard>>(endpoint, { params })
  let items = Array.isArray((data as any).results) ? (data as any).results : (data as any).items || []
  // "Subscriptions" in the filter drawer is intended to show subscription-gated Pixes.
  // The backend may not have a dedicated subscriptions feed endpoint in all envs,
  // so enforce the filter client-side for predictable behavior.
  if (filters?.mode === 'subscriptions') {
    items = (items as any[]).filter((p: any) => {
      const lvl = p?.access_level
      return lvl === 'SUBSCRIBERS_ONLY' || lvl === 'SUBSCRIBERS_OR_PPV'
    })
  }
  const rawNext = (data as any).next_cursor ?? (data as any).next ?? null
  const next = normalizeCursor(rawNext)
  return { items, next }
}
